import React from 'react';

function Select({name, id, customchange, children}){
    
    return <></>;
}

export default Select;